import React, { memo } from "react";
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  Paper,
} from "@mui/material";
import { useSnackbar } from "notistack";

import useTabelaNotasFiscaisExpansivel from "../../hooks/useTabelaNotasFiscaisExpansivel";
import CabecalhoNotasFiscais from "./components/CabecalhoNotasFiscais";
import LinhaNotaFiscal from "./components/LinhaNotaFiscal";
import DetalheRateioNota from "./components/DetalheRateioNota";
import LinhasSkeleton from "./components/LinhasSkeleton";
import LinhaVazia from "./components/LinhaVazia";

function TabelaNotasFiscaisExpansivel({
  rows,
  loading = false,
  buscarCompetenciasNota,
  salvarCompetenciasNota,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const {
    orderBy,
    orderDirection,
    expandedRowIds,
    draftByRow,
    loadingByRow,
    savingByRow,
    errorsByRow,
    sortedRows,
    handleRequestSort,
    handleToggleExpand,
    handleAddCompetencia,
    handleRemoveCompetencia,
    handleChangeCompetencia,
    handleCancelarEdicao,
    handleSalvarCompetencias,
  } = useTabelaNotasFiscaisExpansivel({
    rows,
    buscarCompetenciasNota,
    salvarCompetenciasNota,
    enqueueSnackbar,
  });

  return (
    <TableContainer component={Paper}>
      <Table size="small" aria-label="Tabela de notas fiscais">
        <TableHead>
          <CabecalhoNotasFiscais
            orderBy={orderBy}
            orderDirection={orderDirection}
            onRequestSort={handleRequestSort}
          />
        </TableHead>
        <TableBody>
          {loading && <LinhasSkeleton />}

          {!loading &&
            sortedRows.map((row) => {
              const rowId = row.id;

              return (
                <React.Fragment key={rowId}>
                  <LinhaNotaFiscal
                    row={row}
                    isExpanded={!!expandedRowIds[rowId]}
                    onToggleExpand={() => handleToggleExpand(row)}
                  />
                  <DetalheRateioNota
                    row={row}
                    isExpanded={!!expandedRowIds[rowId]}
                    isLoading={!!loadingByRow[rowId]}
                    isSaving={!!savingByRow[rowId]}
                    draft={draftByRow[rowId] ?? []}
                    erro={errorsByRow[rowId]}
                    onAdd={() => handleAddCompetencia(rowId)}
                    onRemove={(index) => handleRemoveCompetencia(rowId, index)}
                    onChange={(index, field, value) =>
                      handleChangeCompetencia(rowId, index, field, value)
                    }
                    onCancelar={() => handleCancelarEdicao(rowId)}
                    onSalvar={() => handleSalvarCompetencias(row)}
                  />
                </React.Fragment>
              );
            })}

          {!loading && rows.length === 0 && <LinhaVazia />}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default memo(TabelaNotasFiscaisExpansivel);
